import { render } from "./OrderTable.vue?vue&type=template&id=24b2eb1e&ts=true"
import script from "./OrderTable.vue?vue&type=script&lang=ts"
export * from "./OrderTable.vue?vue&type=script&lang=ts"

import "./OrderTable.vue?vue&type=style&index=0&id=24b2eb1e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__